export const sessionStorageKeys = {
  authKeySets: 'auth_key_sets',
};
